import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6up52xmb2z: FaireBrandEntity = {
  token: "b_6up52xmb2z",
  type: "brand",
  name: "Trendy Transfers",
  avatarUrl:
    "https://cdn.faire.com/fastly/76ab73fea9cc326d9b4b1c702d3543621cfbe09c7975734b199d3e84d54229b6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fefcfcc13495b4662d0ebf98e3401c56a37283a56d41d53dc3d3f3a4ccd6c13e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/76ab73fea9cc326d9b4b1c702d3543621cfbe09c7975734b199d3e84d54229b6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fefcfcc13495b4662d0ebf98e3401c56a37283a56d41d53dc3d3f3a4ccd6c13e.png",
  location: "Indianola, IA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 250,
  isTopShop: true,
  isInsider: true,
  description:
    "Trendy Transfers is a one-stop shop for all your apparel decorating needs. We are a women and veteran owned business based out of Iowa. We love helping other boutique owners create unique and trendy items to sell.  With heat transfers, leather patches, chenille patches, vinyl stickers and more, let your creativity shine with any or all of our products.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.989Z",
    importedBy: "entity-db-cli",
  },
};
